import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import axios from 'axios'

const host = "https://api.fswan.cn";

//可以给axios的ajax请求设置统一的主机和端口号
axios.defaults.baseURL = host;
axios.defaults.withCredentials = true;
//将axios这个对象添加到Vue的原型对象中，在使用的时候就只需要使用this.对象名就可以了
Vue.prototype.$http = axios
Vue.prototype.$host = host

// 请求拦截器-------------------------------------------------
axios.interceptors.request.use(config => {

    // 在发送请求之前做些什么
    if (store.state.token) {
        config.headers.Authorization = store.state.token;
    } else {
        let token = localStorage.getItem("user_token");
        let username = localStorage.getItem("username");
        if (token) {
            config.headers.Authorization = token;
            //刷新页面后重新赋值
            store.commit('setToken', token);
            store.commit('setUserName', username);
        }
    }
    return config
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error)
})

// 响应拦截器---------------------------------------------------
axios.interceptors.response.use(response => {
    // 对响应数据做些什么
    return response
}, error => {

    /*let code401 = error.toString().includes('401')
    if (code401) {
        store.commit('setToken', '');
        store.commit('setUserName', '');
        localStorage.removeItem("user_token");
        localStorage.removeItem("username");
    }*/

    let code402 = error.toString().includes('402')
    if (code402) {
        store.commit('setToken', '');
        store.commit('setUserName', '');
        localStorage.removeItem("user_token");
        localStorage.removeItem("username");

        Vue.prototype.$confirm('您未登录，请先登录后操作！', '信息', {
            confirmButtonText: '前往登录',
            cancelButtonText: '暂不登录',
            type: 'warning'
        }).then(() => {
            store.commit('setContentType', '5');
        }).catch(() => {

        });
    }

    let code500 = error.toString().includes('500')
    if (code500) {
        Vue.prototype.$notify({
            title: '500服务器错误！',
            type: 'error',
            offset: 600
        });
    }
    
    return Promise.reject(error)
})

Vue.use(ElementUI)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
